(function () {
  'use strict';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }
    callback();
  }

  function getCookie(name) {
    var escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCookie(name, value, maxAgeSeconds) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + maxAgeSeconds + '; path=/; SameSite=Lax';
  }

  function getWeekToken() {
    var now = new Date();
    var utcDate = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
    var dayNum = utcDate.getUTCDay() || 7;
    utcDate.setUTCDate(utcDate.getUTCDate() + 4 - dayNum);
    var yearStart = new Date(Date.UTC(utcDate.getUTCFullYear(), 0, 1));
    var weekNo = Math.ceil((((utcDate - yearStart) / 86400000) + 1) / 7);
    return utcDate.getUTCFullYear() + '-W' + String(weekNo).padStart(2, '0');
  }

  function normalizePhone(phone) {
    return phone.replace(/[^\d+\s()-]/g, '').trim();
  }

  function setFieldValue(form, name, value) {
    var field = form.querySelector('[name="' + name + '"]');
    if (field) {
      field.value = value;
    }
  }

  function normalizeTag(value) {
    return String(value || '').trim();
  }

  function parseBirthdayTag(birthday) {
    var raw = String(birthday || '').trim();
    var match = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!match) {
      return '';
    }

    var month = match[2];
    var day = match[3];
    return 'aniv_' + month + '-' + day;
  }

  function buildContactTags(existingTags, birthday) {
    var parts = String(existingTags || '')
      .split(',')
      .map(normalizeTag)
      .filter(Boolean);
    var birthdayTag = parseBirthdayTag(birthday);

    if (birthdayTag && parts.indexOf(birthdayTag) === -1) {
      parts.push(birthdayTag);
    }

    return parts.join(',');
  }

  function saveLeadLocally(email, phone, birthday, coupon) {
    try {
      var leads = [];
      var existing = window.localStorage.getItem('cia_popup_leads');
      if (existing) {
        leads = JSON.parse(existing);
      }
      leads.push({ email: email, phone: phone, birthday: birthday, coupon: coupon, ts: Date.now() });
      window.localStorage.setItem('cia_popup_leads', JSON.stringify(leads));
    } catch (e) {
      // localStorage indisponivel
    }
  }

  function fireWebhook(webhookUrl, email, phone, birthday, coupon) {
    if (!webhookUrl) {
      return;
    }
    var clean = String(webhookUrl).trim();
    if (!clean || !/^https?:\/\//i.test(clean)) {
      return;
    }
    fetch(clean, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email,
        phone: phone,
        birthday: birthday,
        coupon_code: coupon,
        source: 'popup-home',
        customer_metafields: [
          {
            namespace: 'custom',
            key: 'aniversario',
            type: 'date',
            value: birthday
          }
        ]
      })
    }).catch(function () { /* ignora falhas silenciosamente */ });
  }

  function parseNewsletterResponse(htmlText) {
    var parser = new window.DOMParser();
    var doc = parser.parseFromString(htmlText, 'text/html');
    var form = doc.getElementById('CiaPopupForm');
    var stateNode = form ? form.querySelector('[data-cia-popup-server-state]') : doc.querySelector('[data-cia-popup-server-state]');
    var errorNode = form ? form.querySelector('[data-cia-popup-error]') : doc.querySelector('[data-cia-popup-error]');
    var state = stateNode ? stateNode.getAttribute('data-cia-popup-server-state') : '';
    var message = errorNode ? errorNode.textContent.replace(/\s+/g, ' ').trim() : '';

    return {
      success: state === 'success',
      errorMessage: message
    };
  }

  function saveLeadToShopify(form) {
    var action = form.getAttribute('action') || window.location.pathname;
    var method = (form.getAttribute('method') || 'post').toUpperCase();
    var body = new URLSearchParams(new window.FormData(form));

    return fetch(action, {
      method: method,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Accept': 'text/html,application/xhtml+xml'
      },
      credentials: 'same-origin',
      body: body.toString()
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('shopify_request_failed');
      }

      return response.text().then(function (htmlText) {
        var result = parseNewsletterResponse(htmlText);

        if (!result.success) {
          throw new Error(result.errorMessage || 'shopify_submission_failed');
        }

        return result;
      });
    });
  }

  function isPopupForm(target) {
    return !!(target && target.matches && target.matches('[data-cia-popup-form], #CiaPopupForm'));
  }

  onReady(function () {
    var root = document.querySelector('[data-cia-popup-root]');
    if (!root) {
      return;
    }

    var overlay = root.querySelector('[data-cia-popup-overlay]');
    var popup = root.querySelector('[data-cia-popup-box]');
    var closeButtons = root.querySelectorAll('[data-cia-popup-close]');
    var form = root.querySelector('[data-cia-popup-form]');
    if (!form) {
      form = root.querySelector('#CiaPopupForm');
    }
    var error = root.querySelector('[data-cia-popup-error]');
    var submitButton = root.querySelector('[data-cia-popup-submit]');
    var success = root.querySelector('[data-cia-popup-success]');
    var successCoupon = root.querySelector('[data-cia-popup-coupon]');
    var formWrap = root.querySelector('[data-cia-popup-form-wrap]');

    if (!overlay || !popup || !form) {
      return;
    }

    var mode = root.getAttribute('data-show-popup-on') || 'every_7_days';
    var delaySeconds = Number(root.getAttribute('data-popup-delay') || 3);
    var couponCode = root.getAttribute('data-coupon-code') || 'BEMVINDO10';
    var webhookUrl = root.getAttribute('data-webhook-url') || '';
    var SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
    var cookieName = 'cia_popup_shown';
    var cookieValue = getCookie(cookieName);
    var weekToken = getWeekToken();
    var weekStorageKey = 'cia_popup_week_seen';
    var every7StorageKey = 'cia_popup_last_shown_ts';
    var weekStorageValue = '';
    var every7LastTs = 0;

    try {
      weekStorageValue = window.localStorage.getItem(weekStorageKey) || '';
      every7LastTs = Number(window.localStorage.getItem(every7StorageKey) || 0);
    } catch (errorStorage) {
      weekStorageValue = '';
    }

    var hasShownThisWeek = cookieValue === weekToken || weekStorageValue === weekToken;
    var hasShownInLast7Days = every7LastTs > 0 && (Date.now() - every7LastTs) < SEVEN_DAYS_MS;

    function shouldShow() {
      if (mode === 'always') {
        return !cookieValue;
      }

      if (mode === 'first_visit') {
        return !hasShownThisWeek;
      }

      if (mode === 'every_7_days') {
        return !hasShownInLast7Days;
      }

      if (mode === 'exit_intent') {
        return !cookieValue;
      }

      return false;
    }

    function persistShownState() {
      if (mode === 'first_visit') {
        setCookie(cookieName, weekToken, 2592000);
        try {
          window.localStorage.setItem(weekStorageKey, weekToken);
        } catch (errorStorage) {
          // Ignore storage restrictions.
        }
        return;
      }

      if (mode === 'every_7_days') {
        var nowTs = String(Date.now());
        setCookie(cookieName, nowTs, 2592000);
        try {
          window.localStorage.setItem(every7StorageKey, nowTs);
        } catch (errorStorage) {
          // Ignore storage restrictions.
        }
        return;
      }

      setCookie(cookieName, '1', 2592000);
    }

    function openPopup() {
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cia-popup-open');
      persistShownState();
    }

    function closePopup() {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cia-popup-open');
    }

    function openByDelay() {
      var safeDelay = Math.max(0, Math.min(10, delaySeconds));
      window.setTimeout(openPopup, safeDelay * 1000);
    }

    function bindExitIntent() {
      var triggered = false;
      document.addEventListener('mouseleave', function (event) {
        if (triggered) {
          return;
        }

        if (window.innerWidth < 992) {
          return;
        }

        if (event.clientY > 8) {
          return;
        }

        triggered = true;
        openPopup();
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) {
        closePopup();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay.classList.contains('is-visible')) {
        closePopup();
      }
    });

    document.addEventListener('submit', function (event) {
      if (!isPopupForm(event.target)) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      error.textContent = '';

      var submittedForm = event.target;
      var formData = new FormData(submittedForm);
      var email = String(formData.get('contact[email]') || '').trim();
      var phone = normalizePhone(String(formData.get('phone') || ''));
      var birthday = String(formData.get('birthday') || '');

      if (!email || !phone || !birthday) {
        error.textContent = 'Preencha todos os campos.';
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        error.textContent = 'Informe um e-mail valido.';
        return;
      }

      submitButton.disabled = true;
      var baseTags = String(formData.get('contact[tags]') || 'newsletter,popup-home');
      var allTags = buildContactTags(baseTags, birthday);
      setFieldValue(submittedForm, 'contact[tags]', allTags);
      setFieldValue(submittedForm, 'contact[phone]', phone);
      setFieldValue(
        submittedForm,
        'contact[body]',
        'Lead popup WhatsApp\n' +
          'Email: ' + email + '\n' +
          'Telefone: ' + phone + '\n' +
          'Aniversario: ' + birthday + '\n' +
          'Cupom: ' + couponCode + '\n' +
          'Origem: popup-home'
      );

      saveLeadToShopify(submittedForm)
        .then(function () {
          saveLeadLocally(email, phone, birthday, couponCode);
          fireWebhook(webhookUrl, email, phone, birthday, couponCode);

          if (formWrap) {
            formWrap.classList.add('cia-popup__hidden');
          }
          successCoupon.textContent = couponCode;
          success.classList.add('is-visible');
        })
        .catch(function (submitError) {
          if (submitError && submitError.message && submitError.message !== 'shopify_submission_failed' && submitError.message !== 'shopify_request_failed') {
            error.textContent = submitError.message;
          } else {
            error.textContent = 'Nao foi possivel concluir seu cadastro agora. Tente novamente.';
          }
        })
        .finally(function () {
          submitButton.disabled = false;
        });
    }, true);

    if (!shouldShow()) {
      return;
    }

    if (mode === 'exit_intent') {
      bindExitIntent();
      return;
    }

    openByDelay();
  });
})();
